import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import './CoverSplit.css';

// Entrypoint from any image from LINK
function CoverSplit({ name, images, size, onlyCover = false, className, style, onClick = null, tag = null, draggable = true }) {
  //NOT OFFICIAL - Quick Fix until the api default cover will change by the Config.DEFAULT_IMG
  const switchCover = (url) => (url.includes(Config.OLD_IMG)) ? Config.DEFAULT_IMG : url;
  const resizeCover = (url) => url.replace(`500x500`, `105x105`).replace(`1400x1400`, `105x105`);
  const resize = (url) => switchCover(resizeCover(url));
  let lock = false;
  const onError = (e) => {
    if (!lock) {
      e.target.src = Config.DEFAULT_IMG;
      lock = true;
    } else {
      e.target.alt = '';
    }
  }
  return (
    <div onClick={onClick}>
      { images.length < 4
        ? (onlyCover)
          ? <div className={className} style={{ width: size, height: size, backgroundImage: `url(${images[0]})`}} />
          : (
            <div>
              <img draggable={draggable} src={images[0] ? resize(images[0]) : Config.DEFAULT_IMG} onError={onError} alt={`${name}`} className={`card-image ${className}`} style={{ width: size, height: size }} />
              {tag && <div className={`tag-cover tc-${tag.toLowerCase()}`}>{tag}</div>}
            </div>
          )
        : (
          <div className={`card-image multi-images`} style={{ width: size, height: size }}>
            { images.slice(0, 4).map( (x,i) => <img draggable={draggable} key={i} src={ images[i] ? resize(images[i]) : Config.DEFAULT_IMG } onError={onError} alt={`${name} #${i}`} style={{ width: size / 2, height: size / 2}} /> ) }
          </div>
        )
      }
    </div>
  )
}

CoverSplit.propTypes = {
  name: PropTypes.string,
  images: PropTypes.array.isRequired,
  size: PropTypes.any.isRequired,
  onlyCover: PropTypes.bool, // Search like Artists
  tag: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object
}

export default CoverSplit;
